import { useQuery } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function useFindSimulationOptions({ proposalId = '', token = '' }) {
  const query = useQuery({
    queryKey: ['find-simulation-options', proposalId, token],
    enabled: false,
    queryFn: async () => {
      const data = await handleFetchResponse(
        fetch(getApiUrl(`energia-solar/v2/simulation/options`), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
    retry: false,
    initialData: {
      legalNatures: [],
      companyTypes: [],
      nationalities: [],
      economicActivityGroups: [],
      economicActivities: [],
      documentTypes: [],
    },
  });

  return query;
}
